import { NgClass } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NgbCollapse } from '@ng-bootstrap/ng-bootstrap';
import { ClaimDto, RoleCardPolicyItem } from 'types/role.interface';

@Component({
  selector: 'app-edit-policy',
  standalone: true,
  imports: [NgClass, NgbCollapse, FormsModule],
  templateUrl: './edit-policy.component.html',
  styleUrl: './edit-policy.component.scss'
})
export class EditPolicyComponent implements OnInit {
  @Input() policy!: RoleCardPolicyItem | any;
  @Input() disabled: boolean = false;
  @Output() policyChange: EventEmitter<RoleCardPolicyItem | any> = new EventEmitter<RoleCardPolicyItem | any>();
  claims: ClaimDto[] | any = [];
  isCollapsed: boolean = true;

  ngOnInit(): void {
    this.claims = this.policy.claims;
    this.claims.sort((a: ClaimDto | any, b: ClaimDto | any) => a.name.localeCompare(b.name));
  }

  handleClaimChange(): void {
    const allChecked = this.claims.every((c: ClaimDto) => c.isEnabled);
    const noneChecked = this.claims.every((c: ClaimDto) => !c.isEnabled);
    this.policy.isEnabled = allChecked;

    this.policyChange.emit({ ...this.policy, claims: this.claims });
  }

  handlePolicyChange(): void {
    this.claims = this.claims.map((c: ClaimDto) => ({
      ...c,
      isEnabled: this.policy.isEnabled
    }));

    this.policyChange.emit({ ...this.policy, claims: this.claims });
  }
}
